/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ /* eslint-disable no-shadow */ import React, {
  useState,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import Filter from './Filter';
import { BillsTable } from './table/BillsTable';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import Loading from '../../components/loading/Loading';
import Create from './modals/Create';
import { formatCurrency } from '../../service/utils';

export default function BillsToPay() {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const today = new Date();
  const monthOptions = [
    { value: 'all', label: t('billsToPay.filter.months.all') },
    { value: '1', label: t('billsToPay.filter.months.january') },
    { value: '2', label: t('billsToPay.filter.months.february') },
    { value: '3', label: t('billsToPay.filter.months.march') },
    { value: '4', label: t('billsToPay.filter.months.april') },
    { value: '5', label: t('billsToPay.filter.months.may') },
    { value: '6', label: t('billsToPay.filter.months.june') },
    { value: '7', label: t('billsToPay.filter.months.july') },
    { value: '8', label: t('billsToPay.filter.months.august') },
    { value: '9', label: t('billsToPay.filter.months.september') },
    { value: '10', label: t('billsToPay.filter.months.october') },
    { value: '11', label: t('billsToPay.filter.months.november') },
    { value: '12', label: t('billsToPay.filter.months.december') },
  ];
  const currentYear = today.getFullYear();
const yearOptions = Array.from({ length: 20 }, (__, i) => ({
  value: (currentYear + 10 - i).toString(),
  label: (currentYear + 10 - i).toString(),
})); 

  const [data, setData] = useState([]);
  const [totalPago, setTotalPago] = useState(0);
  const [totalPendente, setTotalPendente] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [chipData, setChipData] = useState([]);
  const [monthStart, setMonthStart] = useState('all');
  const [yearStart, setYearStart] = useState(currentYear.toString());
  const [monthEnd, setMonthEnd] = useState('all');
  const [yearEnd, setYearEnd] = useState(currentYear.toString())

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [supplier, setSupplier] = useState(null);
  const [category, setCategory] = useState(null);
  const [center, setCenter] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [payingMethod, setPayingMethod] = useState('');
  const [obs, setObs] = useState('');
    
  const [type, setType] = useState('');
  const [predictedValue, setPredictedValue] = useState(''); 
  const [nfeNumber, setNfeNumber] = useState('');
  const [dateIssue, setDateIssue] = useState(null);
  const [bankId, setBankId] = useState(null);

  const [isRecurring, setIsRecurring] = useState(false);
  const [recurrenceType, setRecurrenceType] = useState('');
  const [installmentsCount, setInstallmentsCount] = useState('');


  const handleCleanCreate = () => {
    setSupplier(null);
    setCenter(null);
    setType('');
    setPredictedValue('');
    setNfeNumber('');
    setDateIssue(null);
    setBankId(null);
    setDueDate(null);
    setCategory('');
    setPayingMethod('');
    setObs('');
    setOpenCreate(false);
    setCategory(null);
    setIsRecurring(false);
    setRecurrenceType('');
    setInstallmentsCount('');
  };

 const handleCreate = async () => {
    if (supplier === null && center === null && category == null) {
      notifyError('Escolha pelo menos um fornecedor ou centro de custo');
      return;
    }
    const moneyRegex = /^\d+([.,]\d{1,2})?$/;
    if (!predictedValue || predictedValue.trim().length === 0 || !moneyRegex.test(predictedValue)) {
      notifyError('Insira um valor previsto válido');
      return;
    }
    if (!type) {
      notifyError('Informe o tipo (Fixa ou Variável)');
      return;
    }

    if (payingMethod.length === 0) {
      notifyError('Informe um método de pagamento');
      return;
    }
     if (isRecurring) {
      if (!dueDate) {
        notifyError('Informe a data de vencimento da 1ª parcela');
        return;
      }
      if (!recurrenceType) {
        notifyError('Selecione o tipo de recorrência');
        return;
      }
      const qtd = Number(installmentsCount);
      if (!installmentsCount || Number.isNaN(qtd) || qtd < 2 || qtd > 360) {
        notifyError('Informe o número de repetições (entre 2 e 360)');
        return;
      }
    }

    setLoadingCreate(true);
    try {
      const cleanValue = predictedValue
        .replace(/\./g, '')  
        .replace(',', '.');  
      const { data } = await api.billsToPay.create(
        supplier,
        center,
        category,
        type,
        cleanValue,
        dueDate,
        payingMethod,
        obs,
        nfeNumber,
        dateIssue,
        bankId,
        isRecurring,
        recurrenceType,
        installmentsCount,
      );
      notifySuccess(data.message);
      handleCleanCreate();
      searchData();
    } catch (error) {
      if (error.problems?.length > 0) {
        error.problems.forEach(err => notifyError(err.msg));
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingCreate(false);
    }
  };

  const searchData = async currentChips => {
    setLoading(true);

    const filtersToUse = currentChips || chipData;
    try {
      const bills = await api.billsToPay.getAll(
        filtersToUse,
        itens,
        page + 1,
        monthStart,
        yearStart,
        monthEnd,
        yearEnd,
      );
      const value = await api.billsToPay.getTotalAmount(
        filtersToUse,  
        monthStart,
        yearStart,
        monthEnd,
        yearEnd,
      );
      // const value = await api.billsToPay.getTotalAmount(filtersToUse, month, year);
      setTotal(bills.data.total);
      setData(bills.data.docs);
      setTotalPago(value.data.retorno?.totalPago || 0);
      setTotalPendente(value.data.retorno?.totalPendente || 0);
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  return (
    <>
      <Loading open={loading} msg={t('billsToPay.loading')} />
      <Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'start' }}
        >
          <h3>{t('billsToPay.title')}</h3>
        </Grid>

        <Filter
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
          setPage={setPage}
          setOpenDialog={setOpenCreate}
          monthOptions={monthOptions}
          yearOptions={yearOptions}
          monthStart={monthStart}
          setMonthStart={setMonthStart}
          yearStart={yearStart}
          setYearStart={setYearStart}
          monthEnd={monthEnd}
          setMonthEnd={setMonthEnd}
          yearEnd={yearEnd}
          setYearEnd={setYearEnd}
        />
        <div
          style={{
            marginBottom: '15px',
            display: 'flex',
            justifyContent: 'end',
          }}
        >
          <h4 style={{ marginRight: '16px' }}>{`${t('billsToPay.totalPago')} ${formatCurrency(
            totalPago || 0,
          )}`}</h4>
          <h4>{`${t('billsToPay.totalPendente')} ${formatCurrency(
            totalPendente || 0,
          )}`}</h4>
        </div>
        <BillsTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          searchData={searchData}
        />
      </Grid>
      <Create
        openCreate={openCreate}
        setOpenCreate={setOpenCreate}
        loadingCreate={loadingCreate}
        handleCreate={handleCreate}
        supplier={supplier}
        setSupplier={setSupplier}
        category={category}
        setCategory={setCategory}
        center={center}
        setCenter={setCenter}
        type={type}
        setType={setType}
        predictedValue={predictedValue}
        setPredictedValue={setPredictedValue}
        nfeNumber={nfeNumber}
        setNfeNumber={setNfeNumber}
        dateIssue={dateIssue}
        setDateIssue={setDateIssue}
        bankId={bankId}
        setBankId={setBankId}
        dueDate={dueDate}
        setDueDate={setDueDate}
        payingMethod={payingMethod}
        setPayingMethod={setPayingMethod}
        obs={obs}
        setObs={setObs}
        isRecurring={isRecurring}
        setIsRecurring={setIsRecurring}
        recurrenceType={recurrenceType}
        setRecurrenceType={setRecurrenceType}
        installmentsCount={installmentsCount}
        setInstallmentsCount={setInstallmentsCount}
        handleClean={handleCleanCreate}
      />
    </>
  );
}
